import ListPage from "../../../manager/components/list-page/list-page";
import { IColumn } from "../../../shared/components/normal-table/normal-table";
import "./datamodel-report-list.scss";

const columns: IColumn[] = [
  {
    key: "name",
    displayName: "Name",
    dataType: {
      type: "text",
    }
  },
  {
    key: "created_at",
    displayName: "Created at",
    dataType: {
      type: "dateTime",
    }
  }
];

const DatamodelReportList = () => {
  return (
    <div className="datamodelReportList">
      <ListPage
        title={"Datamodel reports"}
        defaultSortCol={"name"}
        columns={columns}
        dataUrl={{
          url: "reports",
          backend: "platform"
        }}
        deleteUrl={undefined}
      />
    </div>
  );
};

export default DatamodelReportList;